module.exports = __webpack_public_path__ + "img/patient-voice.63d58114.svg";